import { buildSetPrinterModeCommand } from "./protocol";

/** Luck Jingle app content mode — how the printer processes the job. */
export type LuckContentMode = "text" | "image";

export type ContentModeOption = {
  value: LuckContentMode;
  label: string;
  hint: string;
};

export const CONTENT_MODE_OPTIONS: ContentModeOption[] = [
  {
    value: "image",
    label: "Image",
    hint: "ຄມຊັດ — ແນະນຳສຳລັບປ້າຍຂົນສົ່ງ (bitmap ຈາກ layout)",
  },
  {
    value: "text",
    label: "Text",
    hint: "ໂຕອັກສອນລ້ວນ — ໄວກວ່າ ແຕ່ບໍ່ຮອງຮັບ layout ສີ",
  },
];

/** 0 = text, 1 = image (LuckPrinter SDK `10 FF 30 27`). */
export function buildContentModeCommand(mode: LuckContentMode): Uint8Array {
  return buildSetPrinterModeCommand(mode === "image" ? 1 : 0);
}

export function contentModeRasterThreshold(mode: LuckContentMode): number {
  return mode === "image" ? 155 : 128;
}
